import React from "react";
import logger from "logger";
import { getStyleJSON } from "Utils/Common";
import { withRouter } from "react-router-dom";
import { ToolbarButton } from "Common/ToolbarButton";
import Toolbar from "@material-ui/core/Toolbar";

const TaskHistoryToolbar = function(props) {
  const { AccountDetailData } = props;
  return (
    <Toolbar
      style={getStyleJSON(
        `background-color: var(--menubarbackgroundcolor);min-height: auto;`
      )}
    >
      <div layout="row" className="layout-row">
        <div>
          <h1 className="ng-binding">{AccountDetailData.playerservername}</h1>
          <div>
            <ToolbarButton
              label={"Back"}
              tooltip={`Go Back`}
              onClick={props.history.goBack}
            />
          </div>
        </div>
      </div>
    </Toolbar>
  );
};

export default withRouter(TaskHistoryToolbar);
